import env from '@src/environment';

export const { toInt, toDec, format } = {
    /**
     * @description Parse value of string to number
     * @param v
     * @returns
     */
    toInt: (s: string): number => {
        // const num = parseFloat(s.replace(/[^0-9.]/g, ''));
        // return isNaN(num) ? 0 : Math.round(num);
        return isNaN(parseInt(s.replace(/[^0-9]/g, '')))
            ? 0
            : parseInt(s.replace(/[^0-9]/g, ''));
    },

    /**
     * @description Parse value of string to decimal
     * @param s
     * @returns
     */
    toDec: (s: string): number => {
        if (s.includes(',')) {
            // Replace thousand separator '.' with an empty string
            // Replace decimal separator ',' with '.'
            s = s.replace(/\./g, '').replace(',', '.');
        } else {
            // Replace thousand separator ',' with an empty string
            // The decimal separator is already '.'
            s = s.replace(/,/g, '');
        }

        return parseFloat(s);
    },

    /**
     * @description Format number to locale
     * @param v
     * @returns
     */
    format: (n: number) => Intl.NumberFormat(env.localFormat).format(n),
};
